import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row g-xl-5 g-3" }

import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { condimentListLanguage } from '@/core/locales/condiment-list-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'indexAddCondiment',
  setup(__props) {

const { t } = useI18n({
  messages: condimentListLanguage
});

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const addcondiment = defineAsyncComponent(() => import("@/components/theme/ecommerce/condimentadd/addcondiment.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-sm-12",
        text: "true",
        headerTitle: "true",
        title: _unref(t)('Add/Edit Condiment')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(addcondiment))
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})